import React from 'react';
import {
  MinimalBackgroundSystem,
  StatusIndicator,
  DotMatrix,
  ShellName,
  UptimeCounter,
  GlassContainer,
  Badge
} from './shell-design-system';

function PlaceholderApp() {
  return (
    <MinimalBackgroundSystem showGrid={true}>
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        fontFamily: 'var(--font-mono)'
      }}>
        <GlassContainer style={{
          textAlign: 'center',
          maxWidth: '500px',
          width: '100%',
          padding: '48px 32px'
        }}>
          {/* Shell Name */}
          <ShellName style={{
            fontSize: 'clamp(32px, 8vw, 48px)',
            marginBottom: '24px'
          }} />

          {/* Status Badge */}
          <div style={{ marginBottom: '32px' }}>
            <StatusIndicator status="online" showText size="lg" />
          </div>

          {/* Ready Display */}
          <div style={{
            backgroundColor: 'var(--surface-secondary)',
            border: '1px solid var(--surface-border)',
            borderRadius: 'var(--radius-lg)',
            padding: '24px',
            marginBottom: '24px'
          }}>
            <DotMatrix value="READY" size="large" />
          </div>

          {/* Uptime Counter */}
          <div style={{ marginBottom: '24px' }}>
            <UptimeCounter />
          </div>

          {/* Quick Links */}
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            marginBottom: '24px'
          }}>
            <a
              href="/sshd"
              style={{
                padding: '8px 16px',
                backgroundColor: 'var(--surface-secondary)',
                border: '1px solid var(--surface-border)',
                borderRadius: 'var(--radius-md)',
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                fontSize: '0.75rem',
                fontWeight: '500',
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.borderColor = 'var(--accent-primary)';
                e.target.style.color = 'var(--text-primary)';
              }}
              onMouseOut={(e) => {
                e.target.style.borderColor = 'var(--surface-border)';
                e.target.style.color = 'var(--text-secondary)';
              }}
            >
              SSH Monitor
            </a>
          </div>

          {/* Footer */}
          <div style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Badge variant="secondary">Shell System</Badge>
            <Badge variant="primary">v4.0</Badge>
          </div>
        </GlassContainer>
      </div>
    </MinimalBackgroundSystem>
  );
}

export default PlaceholderApp;
